'use strict';

var _ = require('lodash');
var DayOfWeekController = function DayOfWeekController($scope, DowConstants) {
  $scope.allDowArray = $scope.daysFullNames ? DowConstants.ALL_DOW_IDS_FULL : DowConstants.ALL_DOW_IDS;
  $scope.dowArray = _.cloneDeep($scope.daysFullNames ? DowConstants.DOW_OPTIONS_FULL : DowConstants.DOW_OPTIONS);
  $scope.getAllDays = function () {
    return _.cloneDeep($scope.daysFullNames ? DowConstants.ALL_DOW_IDS_FULL : DowConstants.ALL_DOW_IDS);
  };
};
DayOfWeekController.$inject = ['$scope', 'DowConstants'];
module.exports = DayOfWeekController;